import { ApolloClient, ApolloProvider } from '@apollo/client'
import { FarolProvider } from '@farol-ds/react'

import {
  ValidateOabModalWithProvider,
  ValidateOabModalWithProviderProps,
} from './validate-oab-modal-with-provider'

export interface ValidateOabModalProps extends ValidateOabModalWithProviderProps {
  client: ApolloClient<object>
}

export function ValidateOabModal(props: ValidateOabModalProps) {
  return (
    <FarolProvider>
      <ApolloProvider client={props.client}>
        <ValidateOabModalWithProvider {...props} />
      </ApolloProvider>
    </FarolProvider>
  )
}
